import React from 'react';

// Utils
import { elementContextMenuConnect } from '../../../../contextMenu/ElementContextMenuItemsContainer';
import { useTranslator } from '../../../../../components/i18n/useTranslator';

// Components
import SheetMenu from '../../../../../mobile/structural/sheet/menu/SheetMenu';
import Icon from '../../../../../components/icons/Icon';

type MobileElementContextMenuContentProps = {
    showCutCopy: boolean;
    canGroupInColumn: boolean;
    lockToolWillEnableLock: boolean;
    showBringToFront: boolean;
    showSendToBack: boolean;
    singleLink: boolean;
    cut: () => void;
    copy: () => void;
    dispatchDuplicateElements: () => void;
    groupInColumn: () => void;
    toggleLock: () => void;
    bringToFront: () => void;
    sendToBack: () => void;
    deleteElement: () => void;
    copyLinkAddress: () => void;
};

const MobileElementContextMenuContent = (props: MobileElementContextMenuContentProps) => {
    const translate = useTranslator('canvas', 'contextMenuItems.mobile');

    return (
        <SheetMenu
            menuItems={[
                {
                    label: translate('cut', 'Cut'),
                    icon: <Icon name="context-menu-cut" />,
                    onClick: props.cut,
                    dismissSheetOnSelect: true,
                    visible: props.showCutCopy,
                },
                {
                    label: translate('copy', 'Copy'),
                    icon: <Icon name="context-menu-copy" />,
                    onClick: props.copy,
                    dismissSheetOnSelect: true,
                    visible: props.showCutCopy,
                },
                {
                    label: translate('copyLinkAddress', 'Copy link address'),
                    icon: <Icon name="context-menu-copy-link" />,
                    onClick: props.copyLinkAddress,
                    dismissSheetOnSelect: true,
                    visible: props.singleLink,
                },
                {
                    label: translate('duplicate', 'Duplicate'),
                    icon: <Icon name="context-menu-duplicate" />,
                    onClick: props.dispatchDuplicateElements,
                    dismissSheetOnSelect: true,
                },
                {
                    label: translate('groupIntoColumn', 'Group into Column'),
                    icon: <Icon name="context-menu-group" />,
                    onClick: props.groupInColumn,
                    dismissSheetOnSelect: true,
                    visible: props.canGroupInColumn,
                },
                {
                    label: props.lockToolWillEnableLock
                        ? translate('lockPosition', 'Lock Position')
                        : translate('unlockPosition', 'Unlock Position'),
                    icon: <Icon name="context-menu-lock" />,
                    onClick: props.toggleLock,
                    dismissSheetOnSelect: true,
                },
                {
                    label: translate('bringToFront', 'Bring to front'),
                    icon: <Icon name="context-menu-order-front" />,
                    onClick: props.bringToFront,
                    dismissSheetOnSelect: true,
                    visible: props.showBringToFront,
                },
                {
                    label: translate('sendToBack', 'Send to back'),
                    icon: <Icon name="context-menu-order-back" />,
                    onClick: props.sendToBack,
                    dismissSheetOnSelect: true,
                    visible: props.showSendToBack,
                },
                {
                    label: translate('moveToTrash', 'Move to trash'),
                    icon: <Icon name="context-menu-trash" />,
                    onClick: props.deleteElement,
                    dismissSheetOnSelect: true,
                },
            ]}
        />
    );
};

export default elementContextMenuConnect(MobileElementContextMenuContent);

